import { OnboardingWizard } from "@/components/onboarding/OnboardingWizard";

/**
 * Onboarding Page — full-screen route displayed after first sign-up.
 * Contains the multi-step onboarding wizard.
 */
export default function Onboarding() {
  return (
    <main className="gfg-auth-screen">
      <OnboardingWizard />
    </main>
  );
}
